module.exports = __webpack_public_path__ + "static/media/infoslide2.0a16543c.jpg";